/* CDS Cart Gift Wrap — loaded globally so it survives cart drawer DOM refreshes */
(function(){
  'use strict';

  var debounceTimer = null;

  function bindGiftWrap(wrap){
    if(!wrap || wrap._cwBound) return;
    wrap._cwBound = true;

    var toggleEl = wrap.querySelector('[data-cds-cart-gw-toggle]');
    var minusBtn = wrap.querySelector('[data-cds-cart-gw-minus]');
    var plusBtn  = wrap.querySelector('[data-cds-cart-gw-plus]');
    var noteInput = wrap.querySelector('[data-cds-cart-gw-note]');

    if(toggleEl) toggleEl.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      if(wrap.classList.contains('is-busy')) return;
      if(wrap.classList.contains('is-active')){
        removeGW(wrap);
      } else {
        addGW(wrap);
      }
    });

    if(minusBtn) minusBtn.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      var qEl = wrap.querySelector('[data-cds-cart-gw-qty]');
      var q = parseInt(qEl.textContent) || 1;
      if(q <= 1) return;
      q--;
      qEl.textContent = q;
      debouncedUpdate(wrap, q);
    });

    if(plusBtn) plusBtn.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      var qEl = wrap.querySelector('[data-cds-cart-gw-qty]');
      var q = parseInt(qEl.textContent) || 1;
      q++;
      qEl.textContent = q;
      debouncedUpdate(wrap, q);
    });

    if(noteInput){
      noteInput.addEventListener('click', function(e){ e.stopPropagation(); });
      noteInput.addEventListener('input', function(){
        if(!wrap.classList.contains('is-active')) return;
        var qEl = wrap.querySelector('[data-cds-cart-gw-qty]');
        var q = parseInt(qEl.textContent) || 1;
        debouncedUpdate(wrap, q);
      });
    }
  }

  function bindAll(){
    document.querySelectorAll('[data-cds-cart-gw]').forEach(bindGiftWrap);
  }

  /* Initial bind */
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }

  /* Re-bind after DOM changes (cart drawer refresh via sections API) */
  var observer = new MutationObserver(function(mutations){
    for(var i = 0; i < mutations.length; i++){
      if(mutations[i].addedNodes.length){
        bindAll();
        return;
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  /* ── Add gift wrap ── */
  function addGW(wrap){
    wrap.classList.add('is-busy');
    var vid = wrap.dataset.variantId;
    var noteInput = wrap.querySelector('[data-cds-cart-gw-note]');
    var qEl = wrap.querySelector('[data-cds-cart-gw-qty]');
    var qty = parseInt(qEl ? qEl.textContent : '1') || 1;
    var note = noteInput ? noteInput.value.trim() : '';
    var body = { id: parseInt(vid), quantity: qty, properties: {} };
    if(note) body.properties['Note emballage'] = note;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
      body: JSON.stringify(body)
    })
    .then(function(r){ return r.json(); })
    .then(function(){
      wrap.classList.add('is-active');
      wrap.classList.remove('is-busy');
      refreshCartDrawer();
    })
    .catch(function(){ wrap.classList.remove('is-busy'); });
  }

  /* ── Remove gift wrap ── */
  function removeGW(wrap){
    wrap.classList.add('is-busy');
    var pid = wrap.dataset.productId;

    fetch('/cart.js')
    .then(function(r){ return r.json(); })
    .then(function(cart){
      var key = null;
      for(var i = 0; i < cart.items.length; i++){
        if(String(cart.items[i].product_id) === pid){ key = cart.items[i].key; break; }
      }
      if(!key){ wrap.classList.remove('is-active', 'is-busy'); return Promise.resolve(); }
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
        body: JSON.stringify({id: key, quantity: 0})
      });
    })
    .then(function(r){ if(r && r.json) return r.json(); })
    .then(function(){
      wrap.classList.remove('is-active', 'is-busy');
      var qEl = wrap.querySelector('[data-cds-cart-gw-qty]');
      if(qEl) qEl.textContent = '1';
      var ni = wrap.querySelector('[data-cds-cart-gw-note]');
      if(ni) ni.value = '';
      refreshCartDrawer();
    })
    .catch(function(){ wrap.classList.add('is-active'); wrap.classList.remove('is-busy'); });
  }

  /* ── Debounced update (qty/note) ── */
  function debouncedUpdate(wrap, qty){
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function(){
      if(!wrap.classList.contains('is-active')) return;
      wrap.classList.add('is-busy');
      var pid = wrap.dataset.productId;
      var vid = wrap.dataset.variantId;
      var noteInput = wrap.querySelector('[data-cds-cart-gw-note]');
      var note = noteInput ? noteInput.value.trim() : '';

      fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var key = null;
        for(var i = 0; i < cart.items.length; i++){
          if(String(cart.items[i].product_id) === pid){ key = cart.items[i].key; break; }
        }
        if(!key) return Promise.resolve();
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
          body: JSON.stringify({id: key, quantity: 0})
        });
      })
      .then(function(r){ if(r && r.json) return r.json(); })
      .then(function(){
        var body = { id: parseInt(vid), quantity: qty, properties: {} };
        if(note) body.properties['Note emballage'] = note;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
          body: JSON.stringify(body)
        });
      })
      .then(function(r){ return r.json(); })
      .then(function(){ wrap.classList.remove('is-busy'); refreshCartDrawer(); })
      .catch(function(){ wrap.classList.remove('is-busy'); });
    }, 800);
  }

  /* ── Refresh cart drawer ── */
  function refreshCartDrawer(){
    fetch('/cart.js')
    .then(function(r){ return r.json(); })
    .then(function(c){
      document.querySelectorAll('.cart-count,[data-cart-count],.cds-hg__badge').forEach(function(e){
        e.textContent = c.item_count;
      });
      var evt = new Event('cart:update', {bubbles: true});
      evt.detail = {
        resource: {},
        sourceId: 'cds-cart-gift-wrap',
        data: { source: 'cds-cart-gift-wrap', itemCount: c.item_count, sections: {} }
      };
      document.dispatchEvent(evt);
      var sectionIds = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach(function(el){
        if(el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
      });
      if(sectionIds.length){
        fetch('/cart?sections=' + sectionIds.join(','))
        .then(function(r){ return r.json(); })
        .then(function(sections){
          sectionIds.forEach(function(sid){
            if(!sections[sid]) return;
            var parser = new DOMParser();
            var newDoc = parser.parseFromString(sections[sid], 'text/html');
            var target = document.querySelector('cart-items-component[data-section-id="' + sid + '"]');
            if(target){
              var newContent = newDoc.querySelector('cart-items-component') || newDoc.querySelector('.cart-items__wrapper');
              if(newContent) target.innerHTML = newContent.innerHTML;
            }
          });
        });
      }
    });
  }
})();
